<form onsubmit="searchSupplier()">
  <div class="ui-g filterPanel">
    <div class="ui-g-3">
      <span class="md-inputfield filterItem">
        <input name="name" type="text" pInputText [(ngModel)]="supplierFilter.name" />
        <label>Name</label>
      </span>
    </div>

    <div class="ui-g-3">
      <span class="md-inputfield filterItem">
        <input name="postcode" type="text" pInputText [(ngModel)]="supplierFilter.postcode" />
        <label>Postcode</label>
      </span>
    </div>

    <div class="ui-g-3">
      <span class="md-inputfield filterItem">
        <input
          name="classification"
          type="text"
          pInputText
          [(ngModel)]="supplierFilter.classification"
        />
        <label>Classification</label>
      </span>
    </div>

    <div class="ui-g-3 supplier-filter-buttons">
      <button pButton type="submit" label="Search" (click)="searchSupplier()"></button>
      <button pButton type="button" label="Clear" (click)="clearSupplierFilter()"></button>
    </div>
  </div>
</form>
<div class="supplier-container">
  <div class="suppliers-header" style="display: flex">
    <div style="width: 150px; font-size: 12px">
      <button
        type="button"
        class="red-btn"
        pButton
        icon="fa ui-icon-close"
        label="Remove customers"
        [disabled]="selectedSuppliers?.length == 0 || !selectedSuppliers"
        pTooltip="Remove all customers in the 'can work for' column of selected suppliers"
        (click)="removeCustomers()"
      ></button>
    </div>

    <div style="flex-grow: 1; margin-top: auto; margin-bottom: auto; font-weight: 500">
      {{ getSuppliersCount()
      }}<span style="margin-left: 10px" *ngIf="selectedSuppliers?.length > 0">
        ({{ selectedSuppliers?.length }} selected)</span
      >
    </div>

    <div style="width: 150px"></div>
  </div>

  <p-table
    [value]="suppliers"
    [(selection)]="selectedSuppliers"
    dataKey="id"
    [paginator]="true"
    [rows]="10"
    [pageLinks]="8"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 38px">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th>Name</th>
        <th>Postcode</th>
        <th>Classification</th>
        <th>Completion</th>
        <th>Tags</th>
        <th>Can Work For</th>
        <th>Cannot Work For</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr [pSelectableRow]="item">
        <td>
          <p-tableCheckbox [value]="item"></p-tableCheckbox>
        </td>
        <td>{{ item.name }}</td>
        <td>{{ item.postcode }}</td>
        <td>{{ item.supplierOperationalData?.classification }}</td>
        <td>
          <span>{{ (item.supplierOperationalData?.completionRateAllJobs || 0) + '%' }}</span>
        </td>
        <td>
          <div *ngFor="let tag of item.organisationTags">
            <div style="display: flex">
              <div
                class="tag-name"
                style="flex-grow: 1"
                [ngClass]="{ 'tag-name-inactive': tag.tagEntity.inactiveDate != null }"
              >
                {{ tag.tagEntity.name }}
              </div>
              <div
                style="
                  flex-shrink: 1;
                  padding-left: 5px;
                  cursor: pointer;
                  margin-top: auto;
                  margin-bottom: auto;
                  font-size: 1.15rem;
                "
                (click)="removeTag(tag)"
              >
                <i class="fa fa-trash"></i>
              </div>
            </div>
          </div>
        </td>
        <td>
          <div *ngIf="!item.supplierOrderPreferences || item.supplierOrderPreferences.length == 0">
            Any allowed customer
          </div>
          <div *ngFor="let pref of item.supplierOrderPreferences; let i = index">
            <div class="supplier-included-customers">{{ pref.targetOrganisation.name }}</div>
            <div
              *ngIf="pref.targetCustomerDepartment || pref.targetCustomerTeam"
              class="supplier-included-department-team"
            >
              {{ getOrderPreferenceDetails(pref) }}
            </div>
            <div
              *ngIf="!pref.targetCustomerDepartment && !pref.targetCustomerTeam"
              class="supplier-included-spacer"
            ></div>
          </div>
          <div
            class="include-customers-reason"
            *ngIf="item.supplierOrderPreferences && item.supplierOrderPreferences.length > 0"
          >
            Reason: {{ item.supplierOrderPreferences[0].reason }}
          </div>
        </td>
        <td>
          <div
            *ngIf="
              !item.supplierTargetOrderPreferences ||
              item.supplierTargetOrderPreferences.length == 0
            "
          >
            N/A
          </div>
          <div *ngFor="let pref of item.supplierTargetOrderPreferences; let i = index">
            <div class="excluded-customers">
              &bull;{{ pref.organisationName }}
              <div class="sub-name" *ngIf="pref.deptName">Dept: {{ pref.deptName }}</div>
              <div class="sub-name" *ngIf="pref.teamName">Team: {{ pref.teamName }}</div>
            </div>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="footer">
      <tr>
        <td colspan="6">
          <ul>
            <li *ngFor="let supplier of selectedSuppliers" style="text-align: left">
              {{ supplier.name }}
            </li>
          </ul>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <!-- DATATABLE DEPRECATED ---
  <p-dataTabl [value]="suppliers" [(selection)]="selectedSuppliers" dataKey="id"
               [paginator]="true" [rows]="10" [pageLinks]="8" [headerCheckboxToggleAllPages]="true">
      <p-column [style]="{'width':'38px'}" selectionMode="multiple"></p-column>
      <p-column field="name" header="Name" sortField="name" [sortable]="true"></p-column>
      <p-column field="postcode" header="Postcode"></p-column>
      <p-column field="supplierOperationalData?.classification" header="Classification"
                sortField="supplierOperationalData?.classification" [sortable]="true"></p-column>
      <p-column field="supplierOperationalData?.completionRateAllJobs" header="Completion"
                sortField="supplierOperationalData?.completionRateAllJobs" [sortable]="true">
          <ng-template let-supplier="rowData" pTemplate="body">
              <span>{{(supplier.supplierOperationalData?.completionRateAllJobs || 0) + '%'}}</span>
          </ng-template>
      </p-column>
      <p-column field="tags" header="Tags">
          <ng-template let-supplier="rowData" pTemplate="body">
              <div class="tag-name" [ngClass]="{'tag-name-inactive': tag.tagEntity.inactiveDate != null}" *ngFor="let tag of supplier.organisationTags">
                  <span>{{tag.tagEntity.name}}</span>
              </div>
          </ng-template>
      </p-column>
      <p-column field="orderPreferences" header="Can work for">
          <ng-template let-supplier="rowData" pTemplate="body">
              <div *ngIf="!supplier.supplierOrderPreferences || supplier.supplierOrderPreferences.length == 0">Any allowed customer</div>
              <div *ngFor="let pref of supplier.supplierOrderPreferences; let i = index">
                  <div class="supplier-included-customers">{{ pref.targetOrganisation.name }}</div>
                  <div *ngIf="pref.targetCustomerDepartment || pref.targetCustomerTeam"
                       class="supplier-included-department-team">{{ getOrderPreferenceDetails(pref) }}</div>
                  <div *ngIf="!pref.targetCustomerDepartment && !pref.targetCustomerTeam"
                       class="supplier-included-spacer"> </div>
              </div>
              <div class="include-customers-reason" *ngIf="supplier.supplierOrderPreferences && supplier.supplierOrderPreferences.length > 0">
                  Reason: {{ supplier.supplierOrderPreferences[0].reason }}
              </div>
          </ng-template>
      </p-column>
      <p-column field="supplierTargetOrderPreferences" header="Cannot work for">
          <ng-template let-supplier="rowData" pTemplate="body">
              <div *ngIf="!supplier.supplierTargetOrderPreferences || supplier.supplierTargetOrderPreferences.length == 0">N/A</div>
              <div *ngFor="let pref of supplier.supplierTargetOrderPreferences; let i = index">
                  <div class="excluded-customers">&bull;{{ pref.organisationName }}
                      <div class="sub-name" *ngIf="pref.deptName">Dept: {{pref.deptName}}</div>
                      <div class="sub-name" *ngIf="pref.teamName">Team: {{pref.teamName}}</div>
                  </div>
              </div>
          </ng-template>
      </p-column>
      <p-footer>
          <ul>
              <li *ngFor="let supplier of selectedSuppliers" style="text-align: left">{{supplier.name}}</li>
          </ul>
      </p-footer>
  </p-dataTable>
  --->
</div>
